(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {

  /* ===== GROUP ACCORDION ===== */
  const groupToggles = document.querySelectorAll('.group-toggle');

  groupToggles.forEach(toggle => {
    toggle.addEventListener('change', () => {
      if (toggle.checked) {
        groupToggles.forEach(other => {
          if (other !== toggle) {
            other.checked = false;
          }
        });
      }
    });
  });

  /* ===== INNER FAQ ACCORDION ===== */
  const faqGroups = document.querySelectorAll('.faq-group');

  faqGroups.forEach(group => {
    const itemToggles = group.querySelectorAll('.item-toggle');

    itemToggles.forEach(toggle => {
      toggle.addEventListener('change', () => {
        if (toggle.checked) {
          itemToggles.forEach(other => {
            if (other !== toggle) {
              other.checked = false;
            }
          });
        }
      });
    });
  });

});

  } catch(e) { console.error(e); }
})();
})();
